import './driverInfo.css';
import driverImg from '../../assets/images/user-2.png';

const DriverInfo = ({data}) => {
    return(
        <div className={'accordion-sec'}>
            <div className="accordion-head padding-tb-20 sf-medium">
                <div className="head-content flex gap-40">
                    <div className="rating-box">4.8</div>
                    {/*<div className="user-img icon">*/}
                    {/*    <img src={driverImg} alt=""/>*/}
                    {/*</div>*/}
                    <ul className="separator gap-50">
                        {
                            data.map((item, index) =>
                                <li key={index} className={item?.class}>{item?.text}</li>
                            )
                        }
                    </ul>
                </div>
                <div className="plus-minus-icon"></div>
            </div>
        </div>
    )
}

export default DriverInfo;
